module.exports = __webpack_public_path__ + "static/media/kanban.107bdcd9.jpg";